import React, { useState, useEffect, useContext, memo } from "react";
import axios from "axios";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import BatimentTabs from "components/Patrimoine/Batiment/BatimentTabs";
import CompteTabs from "components/Patrimoine/Compte/CompteTabs";
import SiteTabs from "components/Patrimoine/Site/SiteTabs";
import RegionTabs from "components/Patrimoine/Region/RegionTabs";
import ZoneTabs from "components/Patrimoine/Zone/ZoneTabs";
import UrbanEquipmentTabs from "components/Patrimoine/UrbanEquipment/UrbanEquipmentTabs";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import TabHeader from "components/Patrimoine/TabHeader";
import postPageVisit from "services/LogService";

function Patrimoine() {
  const [redirState, setRedirState] = useState(false);
  const [type, setType] = useState(5);
  const [subtype, setSubType] = useState(0);
  const [entiteName, setEntiteName] = useState();
  const [importkey, setImportkey] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage } = appContext;

  useEffect(() => {
    setPage('patrimoine');
    postPageVisit('patrimoine');
  }, []);


  useEffect(() => {
    setType(5);
    setSubType(0);
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      axios
        .get(getSite(chartIdGroup), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          setType(res.data.detail.type);
          let subtype = 0;
          if (res.data.detail.subtype) subtype = res.data.detail.subtype;
          setSubType(subtype);
          setEntiteName(res.data.detail.name);
          setImportkey(res.data.detail.importkey);
        });
    }
  }, [chartIdGroup]);

  const NoTabs = () => {
    return "";
  };

  // let redirecting = redirState && (
  //   <Navigate
  //     push
  //     to={{
  //       pathname: "/admin/patrimoine",
  //     }}
  //   />
  // );

  const entitesType = {
    0: { 0: RegionTabs, 1: RegionTabs, 2: RegionTabs },
    1: { 0: SiteTabs, 1: NoTabs, 2: NoTabs },
    2: { 0: BatimentTabs, 1: UrbanEquipmentTabs, 2: NoTabs },
    3: { 0: ZoneTabs, 1: NoTabs, 2: NoTabs },
    4: { 0: CompteTabs, 1: NoTabs, 2: NoTabs },
    5: { 0: NoTabs, 1: NoTabs, 2: NoTabs },
  };

  const SelectedEntitesType = entitesType[type][subtype];
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/patrimoine",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"patrimoine"}
    >
      {chartIdGroup[0] !== "0" && type != 5 ? (
        <>
          <TabHeader entiteName={entiteName} type={type} subtype={subtype} importkey={importkey} />
          <SelectedEntitesType /></>
      ) : <TabHeader entiteName={""} type={type} subtype={subtype} />
      }

      {redirecting}
    </ErrorBoundary>
  );
}

export default Patrimoine;
